import { makeStyles } from '@material-ui/core/styles';
import { i18n } from '../../../language';
import Notify from './notify';
import NotificationHead from './notificationHead';

// 使用Notification組件時需要給該組件的context屬性傳入對象數組
// 對象數組中的對象具有的屬性{id, title, time, context}
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: '4.375rem',
    right: 0,
    bottom: '0',
    width: '19.438rem',
    backgroundColor: theme.palette.font.white,
  },
  list: {
    overflowX: 'hidden',
    height: '100%',
    overflowY: 'auto',
    paddingBottom: '5.4rem',
  },
}));

export default function Notification(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <NotificationHead head={`${i18n.t('HOME_NOTIFICATION')}(${Object.keys(props.context).length})`} />
      <div className={classes.list}>
        {props.context.map((wardstaff, index) => (
          <Notify title={wardstaff.title} context={wardstaff.context} time={wardstaff.time} key={wardstaff.id} />
        ))}
      </div>
    </div>
  );
}
